import ColumnBlock from '../column-block/column-block';
import TableHead from '../table-head/table-head';
import {
  Department,
  RequirementFactory,
  RequirementColumn,
} from '../../types/data';
import { Report } from '../../types/table';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { useEffect } from 'react';
import { getReportSummary } from 'src/modules/vpo/actions';
import { selectReportSummary } from 'src/modules/vpo/selectors/selectReportSummary';

// Type Guards
const isColumnRequirement = (
  data: RequirementColumn[] | RequirementFactory[],
): data is RequirementColumn[] => {
  return (data as RequirementColumn[])[0]?.columnRequirements !== undefined;
};

const isRequirementFactory = (
  data: RequirementColumn[] | RequirementFactory[],
): data is RequirementFactory[] => {
  return (data as RequirementFactory[])[0]?.shortTitle !== undefined;
};

type TableSummaryProps = {
  data: RequirementColumn[] | RequirementFactory[];
  dataHead: Department[] | RequirementFactory[];
  category: Report;
  isCompleted?: boolean;
};

function TableSummary({ data, dataHead, category, isCompleted }: TableSummaryProps) {
  console.log('category', category)
  return (
    <div
      className={`no-outer-borders w-[100%] overflow-x-auto scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] rounded-md shadow ${category === 'default' ? 'max-h-[calc(100vh-241px)] overflow-y-auto bg-white': ''}`}
    >
      <table className="w-[100%] table-fixed border-collapse border">
        <TableHead
          isFixed={category === 'default'}
          data={dataHead}
          category={category}
        />

        {data.map((element, index) => {
          if (isColumnRequirement(data)) {
            console.log('startFactory')
            return (
              <ColumnBlock
                key={index}
                category={category}
                departments={dataHead}
                {...(element as RequirementColumn)}
                isCompleted={isCompleted as boolean}
              />
            );
          }

          if (isRequirementFactory(data)) {
            const factoryRequirement = (element as RequirementFactory)
              .factoryRequirements[index];

            console.log('startFactory')

            return (
              <ColumnBlock
                key={index}
                category={category}
                dataColumn={dataHead as RequirementFactory[]}
                departments={dataHead}
                {...factoryRequirement}
              />
            );
          }
        })}
      </table>
    </div>
  );
}

export default TableSummary;
